import React, {useState} from 'react';
import {Table} from '@/web-components';
import {getBaseLevelTableHeader} from '../BaseLevelTableHeader';
import CustomScrollDiv from '../../../../shared/components/scroll-bars/custom_scroll_div';
import {PageContent} from '../TaskReport.styled';
import {getBaseLevelTableHeaderTotals} from '../BaseLevelTableHeaderTotals';
import {useGenericReportContext} from '../../../saved-report/GenericReportContext';
import {EXTERNAL_SHARE_TYPE} from '../../../../shared/util/ReportServiceUtil';

const BaseLevelWrapper = ({
	tableHeader,
	getRows,
	enabledColumns,
	currentLength,
	hasNextPage,
	refetch,
	intl,
	currency,
	customFieldColumnCount,
	pageSize,
}) => {
	const {isSharedView, shareType} = useGenericReportContext();

	const [modalTasksFetching, setModalTasksFetching] = useState(false);

	const fetchMore = () => {
		const refetchObject = {};
		if (hasNextPage) {
			setModalTasksFetching(true);
			refetchObject.showLoader = true;
			refetchObject.pageSize = currentLength + pageSize;
			refetch(refetchObject, null, () => setModalTasksFetching(false));
		} else if (modalTasksFetching) {
			setModalTasksFetching(false);
		}
	};

	const handleScroll = e => {
		if (!modalTasksFetching && e.target.scrollHeight - e.target.scrollTop < e.target.clientHeight + 300) {
			fetchMore();
		}
	};

	const tableContent = () => (
		<PageContent>
			<Table>
				{getBaseLevelTableHeader(enabledColumns, tableHeader.customFieldDefinitions)}
				{getBaseLevelTableHeaderTotals(tableHeader, intl, currency, customFieldColumnCount)}
				{getRows()}
			</Table>
		</PageContent>
	);

	const scrollWrapper = () => {
		return (
			<CustomScrollDiv className="custom-scrollbar-div" handleScroll={handleScroll}>
				{tableContent()}
			</CustomScrollDiv>
		);
	};

	return isSharedView && shareType === EXTERNAL_SHARE_TYPE ? tableContent() : scrollWrapper();
};

export default BaseLevelWrapper;
